const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

/**
 * Obtener todos los clientes con filtros
 */
export const fetchClientes = async (filters = {}) => {
  try {
    // Separar los parámetros de paginación de los filtros
    const { page, limit, ...queryFilters } = filters;
    
    const response = await fetch(`${API_URL}/client/list`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: queryFilters,
        page: page || 1,
        limit: limit || 50,
      }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener clientes');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al obtener clientes:', error);
    throw error;
  }
};

/**
 * Obtener clientes por lavandería
 */
export const fetchClientesByLavanderia = async (lavanderiaId, filters = {}) => {
  try {
    // Separar los parámetros de paginación de los filtros
    const { page, limit, ...queryFilters } = filters;
    
    const response = await fetch(`${API_URL}/client/getByLaundryId`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: {
          lavanderiaId,
          ...queryFilters,
        },
        page: page || 1,
        limit: limit || 50,
      }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener clientes por lavandería');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al obtener clientes por lavandería:', error);
    throw error;
  }
};

/**
 * Obtener cliente por ID
 */
export const fetchClienteById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/client/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener cliente');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al obtener cliente:', error);
    throw error;
  }
};

/**
 * Crear nuevo cliente
 */
export const createCliente = async (clienteData) => {
  try {
    const response = await fetch(`${API_URL}/client/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(clienteData),
    });

    if (!response.ok) {
      throw new Error('Error al crear cliente');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al crear cliente:', error);
    throw error;
  }
};

/**
 * Actualizar cliente
 */
export const updateCliente = async (id, clienteData) => {
  try {
    const response = await fetch(`${API_URL}/client/update/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(clienteData),
    });

    if (!response.ok) {
      throw new Error('Error al actualizar cliente');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al actualizar cliente:', error);
    throw error;
  }
};

/**
 * Eliminar cliente
 */
export const deleteCliente = async (id) => {
  try {
    const response = await fetch(`${API_URL}/client/delete/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al eliminar cliente');
    }

    return await response.json();
  } catch (error) {
    console.error('Error al eliminar cliente:', error);
    throw error;
  }
};
